import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import classNames from "classnames";

import style from "./LoadingPage.module.scss";

type LoadingPageProps = {
  className?: string;
  withText?: boolean;
};

export function LoadingPage({ className, withText = true }: LoadingPageProps) {
  return (
    <div className={classNames(style.page, className)}>
      <Loader className={style.loader} />
      {withText && (
        <>
          <h2>Veuillez patienter</h2>
          <p className={style.durationInfo}>
            Nous en avons pour moins d&apos;une minute.
          </p>
        </>
      )}
    </div>
  );
}
